import type { BaseDescriptor } from "building-types/views/baseDescriptorTypes";
import { ViewEntityType } from "building-types/views/viewEntityType";
import type { EntityDescriptor } from "building-types/views/viewEntityTypes";
import uid from "common/utils/uid";

interface LegacyViewEntity {
  readonly entityId: string;
  readonly descriptor: EntityDescriptor;
}

export class ViewEntityTable {
  private readonly entities: { [id: string]: LegacyViewEntity };

  constructor() {
    this.entities = {};
  }

  new(viewEntityType: ViewEntityType): string {
    const entityId = uid();
    const defaultDescriptor: BaseDescriptor = {
      entityType: viewEntityType,
    };
    this.entities[entityId] = { entityId, descriptor: defaultDescriptor };
    return entityId;
  }

  insert(entityId: string, descriptor: EntityDescriptor): string {
    this.entities[entityId] = { entityId, descriptor };
    return entityId;
  }

  getTable(): { [id: string]: LegacyViewEntity } {
    return this.entities;
  }

  getEntityType(entityId: string): ViewEntityType {
    const entity = this.entities[entityId];
    if (!entity?.descriptor) {
      return ViewEntityType.NONE;
    }
    return entity.descriptor.entityType;
  }

  getEntityDescriptor(entityId: string): EntityDescriptor {
    const entity = this.entities[entityId];
    return entity?.descriptor;
  }

  getEntitiesByType(entityType: ViewEntityType) {
    const entities: LegacyViewEntity[] = [];
    for (const entityId in this.entities) {
      const entity = this.entities[entityId];
      if (entity?.descriptor?.entityType === entityType) {
        entities.push(entity);
      }
    }

    return entities;
  }
}
